export class DynamicFormLayoutModel{
    Id: number;
    ClientId: string;
    HttpAlias: string;
    IsDefault: boolean;
    LayoutName: string;
    Name: string;
    RootUrl: string;
    Version: string;

    constructor(id:number, clientid:string, httpAlias:string, isDefault:boolean, layoutName:string, rootUrl:string, version:string){
        this.Id = id;
        this.ClientId = clientid;
        this.HttpAlias = httpAlias;
        this.IsDefault = isDefault;
        this.LayoutName = layoutName;
        this.Name = rootUrl;
        this.RootUrl = rootUrl;
        this.Version = version;
    }

    public static map(data:any){
        var model:DynamicFormLayoutModel = new DynamicFormLayoutModel(data.Id, data.ClientId, data.HttpAlias, data.IsDefault, data.LayoutName, data.RootUrl, data.Version);
        return model;
    }
}